<template>
  <div class="tags">
    <div class="tags__header">
      <div class="tags__title">All Categories</div>
      <input type="serach" class="tags__search" placeholder="Search..." v-model="search">
    </div>
    <div class="tags__alphabets">
      <span class="tags__alphabet" :class="{'is-active': activeKey == 0}" @click="changeLetter(0)">All</span>
      <span class="tags__alphabet" :class="{'is-active': activeKey == key}" v-for="(letter,key) in tags" :key="key" @click="changeLetter(key)">{{key}}</span>
    </div>
    <div class="tags__content">

      <ul class="tags__row">
        <li class="tags__li" v-for="(tag, index) in funded" :key="index">
          <a :href="`/${$root.state.lang}/${tag.slug}`" target="_self" class="tags__link">{{tag.tag}}</a>
        </li>
      </ul>

      <div class="no-found" v-if="search.length > 1 && funded.length == 0">
        <i class="i i-alert"></i>
      </div>


      <div v-if="search.length < 2 && activeKey == 0">
      <div class="tags__col" v-for="(letter,key) in tags" :key="key">
        <div class="tags__letter">{{key}}</div>
        <ul class="tags__row">
          <li class="tags__li" v-for="(tag, index) in letter" :key="index">
            <a :href="`/${$root.state.lang}/${tag.slug}`" target="_self" class="tags__link">{{tag.tag}}</a>
          </li>
        </ul>
      </div>
      </div>

    </div>
  </div>
</template>


<style lang="scss">
.tags {
  &__header {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    @include mq('md') {
      flex-direction: row;
      margin-bottom: 20px;
    }
  }
  &__title {
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: -0.01em;
    color: $color-link-hover;
    display: inline-flex;
    align-items: center;
    @include mq('md') {
      font-size: 24px;
      line-height: 30px;
    }
  }
  &__search {
    height: 40px;
    width: 100%;
    background: $color-background-light;
    border: 0;
    outline: none;
    padding: 9px 20px 11px;
    margin-top: 10px;
    color: $color-link-hover;
    @include mq('md') {
      margin-top: 0;
      margin-left: 20px;
      width: 248px;
    }
  }
  &__alphabets {
    display: flex;
    margin-bottom: 15px;
    overflow-x: scroll;
    @include mq('md') {
      overflow: hidden;
      margin-right: -5px;
      flex-wrap: wrap;
      margin-bottom: 35px;
    }
  }
  &__alphabet {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    min-width: 40px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    background: $color-background-light;
    color: $color-link;
    text-transform: uppercase;
    margin-right: 5px;
    margin-bottom: 5px;
    cursor: pointer;
    &.is-active {
      background: $color-main;
      color: $color-link-hover;
    }
  }
  &__letter {
    background: #36323D;
    color: $color-link-hover;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    padding-top: 9px;
    padding-bottom: 11px;
    padding-left: 15px;
    text-transform: uppercase;
  }
  &__row {
    margin-top: 15px;
    margin-bottom: 15px;
    columns: 140px 7;
    @include mq('md') {
      margin-top: 20px;
      margin-bottom: 30px;
    }
    &:empty {
      display: none;
    }
  }
  &__li {
    margin-bottom: 10px;
  }
  &__link {
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    text-transform: capitalize;
    display: inline-flex;
    &:hover {
      color: $color-link-hover;
    }
  }
}
</style>


<script>
import axios from 'axios'

export default {
  data: () => ({
    search: '',
    activeKey: 0,
    funded: [],
    tags: false,
    data: []
  }),
  methods: {
    async cleaner(data) {
      //let data = [];
      for (let i = 0; i < data.length; i++) {
        let el = data[i];
        el.sort = el.tag.toLowerCase();
        this.data.push(el);
        // if(!~el.eng.indexOf('gay')) {
        //   //this.data.push(el);
        //   if(!~el.eng.indexOf('shemale')) {
        //     this.data.push(el);
        //   }
        // }
        
      }
      return true;
    },
    async getData() {
      this.data = await axios.get(`/cache/tags/${this.$root.state.lang}.json?v=${window.catUpdate}`).then(res=>(res.data));
      
      //await this.cleaner(data);


      this.data.sort((a, b) => {
        //if (a.tag < b.tag) return -1;
        return (a.sort > b.sort) ? 1 : -1
      });


      
      //return;
      let her = {
        '#':[]
      };

      for (let i = 0; i < this.data.length; i++) {

        if(!isNaN(parseInt(this.data[i].sort[0]))) {
          her['#'].push(this.data[i]);
          continue;
        }
        
        if (!her[this.data[i].sort[0]]) {
          her[this.data[i].sort[0]] = [];
        }
        her[this.data[i].sort[0]].push(this.data[i]);
      }


      this.tags = her;
    },
    changeLetter(key) {
      this.activeKey = key;
      this.funded = this.tags[key];
    },
    filterTags() {
      let searchLower = this.search.toLowerCase();
      this.funded = this.data.filter(tag => (
        tag.tag.toLowerCase().indexOf(searchLower) > -1
      ))
    }
  },
  watch: {
    search(val) {
      this.activeKey = 0;
      if(val.length < 2) return this.funded=[];
      this.filterTags(val);
    }
  },
  created() {
    this.getData();
    //axios.get()
  }

}
</script>